import React from 'react';
import LogoutButton from './logoutButton.jsx';
import { apiGet } from '../../../services/apiClient'
import './userInfo.css';

export default class UserInfo extends React.Component {
    constructor(args) {
        super(args);
        this.state = {
            userName: ""
        };
    }

    componentDidMount() {
        this.reload();
    }

    reload(props) {
        apiGet('user/info')
            .then(response => {
                this.setState({
                    userName: response.login
                });
            });
    }

    render() {
        return (
            <div className="navbar-custom-menu">
                <ul className="nav navbar-nav">
                    <li className="user user-menu">
                        <div className="user-menu-inner">
                            <img src="/img/user_icon.png" className="user-image" alt="User Image" />
                            <span>{ this.state.userName }</span>
                        </div>
                    </li>
                    <LogoutButton />
                </ul>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/containers/header/user/userInfo.jsx